import React, { Component } from "react";
import {map, isEmpty, forEach} from "lodash";
import {Avatar, DatePicker, message, Modal, Popconfirm, Select, Steps, Upload} from "antd";
import moment from "moment-timezone";
import {PlusCircleOutlined, UploadOutlined, DeleteOutlined, EnvironmentOutlined, FilePdfOutlined, CloseCircleOutlined, DeleteFilled} from '@ant-design/icons';
import ReactQuill from 'react-quill';
import * as yup from "yup";
import html2canvas from "html2canvas";

import PreviewLetter from "./PreviewLetter";
import DefineLocation from './DefineLocation';
import DefineCoordinates from './DefineCoordinates.jsx';
import ProposalClose from './ProposalClose';
import ActivateService from './ActivateService';
import Details from './Details';
import Loader from "../../../../../Common/Component/Loader";
import CustomMap from "../../Common/CustomMap";
import {errorHandle} from "../../../../../Common/errorHandle";
import CurrencyFormat from 'react-currency-format';
import { formatToCurrency } from "../../../../../../Tools/formatToCurrency";
const { jsPDF } = require("jspdf");

const {Step} = Steps;
const {Option} = Select;

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = [{value: 'weekly', key: 'Weekly'}, {value: 'bi_monthly', key: 'Every Other Week'}, {value: 'once', key: 'Just Once'}, {value: 'twice_weekly', key: 'Twice Weekly'}, {value: 'monthly', key: 'Monthly'}];

// regex for mail
// const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// const MONTH = [
//   {value: 'january', key: 'January'},
//   {value: 'february', key: 'February'},
//   {value: 'march', key: 'March'},
//   {value: 'april', key: 'April'},
//   {value: 'may', key: 'May'},
//   {value: 'june', key: 'June'},
//   {value: 'july', key: 'July'},
//   {value: 'august', key: 'August'},
//   {value: 'september', key: 'September'},
//   {value: 'october', key: 'October'},
//   {value: 'november', key: 'November'},
//   {value: 'december', key: 'December'},
// ];

const PROPOSAL_STATUS = ['enquiry', 'survey_complete', 'proposal_submitted', 'service_activated'];

const PRODUCTS = [{key: 'Pet Waste Stations', value: 'pet_waste_stations'},
  {key: 'Pet Waste Station Bags', value: 'pet_waste_station_bags'},
  {key: 'Other', value: 'other'}];

const SERVICES = [{key: 'Pet Waste Station Service', value: 'pet_waste_station_service'},
  {key: 'Common Area Cleaning', value: 'common_area_cleaning'},
  {key: 'Trash Can Service', value: 'trash_can_service'},
  {key: 'Repair', value: 'repair'},
  {key: 'Other', value: 'other'},  
];


class AddProposal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      loader: false,
      tabs: [{
        uuid: '',
        title: 'PROPOSAL 1',
        header_bag_price:'',
        roll_bag_price:'',
        service_start_date:'',
        checkLength:'',
        items: [{
          type: '',
          item: '',
          model: '',
          regularity: '',
          start_month: '',
          end_month: '',
          description: '',
          discountChecked: false,
          discount: '',
          qty: '',
          rate: '',
          rateTaxChecked: false,
          rateTax: '',
          total: '',
          sh: '',
          shTaxChecked: false,
          shTax: ''
        }],
        itemsService: [{
          type: 'service',
          item: '',
          model: '',
          regularity: '',
          start_month: '',
          end_month: '',
          description: '',
          discountChecked: false,
          discount: '',
          qty: '',
          rate: '',
          rateTaxChecked: false,
          rateTax: '',
          total: '',
          sh: '',
          shTaxChecked: false,
          shTax: '',
          coordinates: '',
          totalCoordinates: '',
          markers:[]
        }],
        itemsProduct: [{
          type: 'product',
          item: '',
          model: '',
          regularity: '',
          start_month: '',
          end_month: '',
          description: '',
          discountChecked: false,
          discount: '',
          qty: '',
          rate: '',
          rateTaxChecked: false,
          rateTax: '',
          total: '',
          sh: '',
          shTaxChecked: false,
          shTax: ''
        }],
      }],
      currentTab: 0,
      siteSurvey: '',
      workScope: '',
      mapNotes: '',
      coverLetter: {},
      selectedPDF: 0,
      btn_active: false,
      addCommercialProposal: {},
      commercialProposalDetail: {},
      editCommercialProposalDetail: {},
      email_body: '',
      location: {
        image: '',
        pdf: '',
        markers: []
      },
      coordinate:{
        image: '',
        pdf: '',
        markers: []
      },
      showPreview: false,
      showLocation: false,
      showCoordinates : false,
      isCloseProposal: false,
      to: '',
      subject: '',
      email_signature: '',
      proposal_due: props?.quoteDetail?.proposal_due,
      isActivateService: false,
      callActiveService: false,
      isDetails: false,
      isSendClick: false,
      callInnerProposal: false,
      tempLocation: false,
      org_markers: [],
      getProposalPdf: '',
      isExportClick: false,
      currentPosition: {},
      quoteDetail: {},
      showConfirmation: false,
      mapZoom: 8,
      is_cover_img: false,
      is_location_pdf: false,
      check_email: false,
      errors: {},
      mailErrors: {},
      isUpdateClick: false,
      isDuplicateClick: false,
      deletedLineItems: [],
      bdaList: {},
      business_development_officer: {},
      deletedInnerProposal: [],
      coordinateIndex:0,
      fieldOffice:{},
      saveProposalSubmit : false
    }
    this.link = null
  }

  UNSAFE_componentWillMount = () => {
    window.scrollTo(0, 0);
  }

  componentDidMount = () => {
    const {quoteDetail} = this.props;
    // getQuoteId(quoteId)
    this.getCommercialProposalDetail();
    // this.props.checkEmail(quoteDetail?.email_address);
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    this.setState({loader: false})
    const {
      addCommercialProposal,
      currentTab,
      isActivateService,
      callActiveService,
      commercialProposalDetail,
      editCommercialProposalDetail,
      callInnerProposal,
      getProposalPdf,
      isExportClick,
      check_email,
      isUpdateClick,
      isSendClick
    } = this.state;

    // error
    if (Object.keys(nextProps?.CommercialProposal?.errors).length > 0 && nextProps?.CommercialProposal?.errors !== this.props?.CommercialProposal?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CommercialProposal?.errors)
    }
    ////////////////////////////////////////////////////////////////////////

    // check email is exist or not
    if (nextProps?.CommercialProposal?.check_email !== check_email) {
      this.setState({ check_email: nextProps?.CommercialProposal?.check_email });
    }

    // add commercial proposal detail
    if (Object.keys(nextProps?.CommercialProposal?.addCommercialProposal).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.addCommercialProposal) !== JSON.stringify(addCommercialProposal)) {
      this.setState({ addCommercialProposal: nextProps?.CommercialProposal?.addCommercialProposal }, () => this.addInnerProposal());
    }

    // Field office proposal detail
    if (Object.keys(nextProps?.EditFieldOffice > 0 &&  
      JSON.stringify(nextProps?.EditFieldOffice))){
      //this.state.fieldOffice = nextProps?.EditFieldOffice;
      this.setState({fieldOffice : nextProps?.EditFieldOffice});
    }

    // update commercial proposal detail
    if (Object.keys(nextProps?.CommercialProposal?.editCommercialProposalDetail).length > 0 &&
      (JSON.stringify(nextProps?.CommercialProposal?.editCommercialProposalDetail) !== JSON.stringify(editCommercialProposalDetail) || isUpdateClick)) {
      // for active service
      if (callActiveService) {
        this.setState({callActiveService: false})
        this.toggleActivateProposal();
        setTimeout(() =>  window.location.reload(this.props.history.replace('/commercial')), 1000)
      }
      // for sending mail
      if (isSendClick) {
        this.props.sendProposalMail(commercialProposalDetail?.uuid)
        this.setState({isSendClick: false})
      }
      this.setState({ editCommercialProposalDetail: nextProps?.CommercialProposal?.editCommercialProposalDetail, isUpdateClick: false }, () => callInnerProposal && this.addInnerProposal());
    }

    // get Proposal detail
    if (Object.keys(nextProps?.CommercialProposal?.getCommercialProposalDetail).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.getCommercialProposalDetail) !== JSON.stringify(commercialProposalDetail)) {
      // for quote detail
      const detail = nextProps?.CommercialProposal?.getCommercialProposalDetail?.commercial_quote;
      const filedDetails = nextProps?.CommercialProposal?.getCommercialProposalDetail?.commercial_quote;
      const data = nextProps?.CommercialProposal?.getCommercialProposalDetail;
      
      if (!isEmpty(detail?.address?.geo_location)) {
        this.setState({currentPosition: {lat: detail?.address.geo_location?.latitude, lng: detail?.address.geo_location?.longitude}})
      }
      
      let tabs = []
      if (data?.inner_proposals?.length > 0) {
        map(data?.inner_proposals, (obj, index) => {
          let items = [];
          let itemsService = [];
          let itemsProduct = [];
          map(obj?.line_items, (line_items) => {
            items.push({
              uuid: line_items?.uuid,
              type: line_items?.item_type,
              item: line_items?.item,
              model: line_items?.model,
              regularity: line_items?.frequency,
              start_month: line_items?.start_month ? moment(`01/${line_items?.start_month}/${line_items?.start_year}`) : '',
              end_month: line_items?.end_month ?  moment(`01/${line_items?.end_month}/${line_items?.end_year}`) : '',
              description: line_items?.description,
              discountChecked: line_items?.discount ? true : false,
              discount: line_items?.discount,
              qty: line_items?.quantity,
              rate: line_items?.rate,
              rateTaxChecked: line_items?.rate_tax ? true : false,
              rateTax: line_items?.rate_tax,
              total: line_items?.total,
              sh: line_items?.s_and_h,
              shTaxChecked: line_items?.s_and_h_tax ? true : false,
              shTax: line_items?.s_and_h_tax
            })
            if(line_items?.item_type === 'service'){
              
              itemsService.push({
                uuid: line_items?.uuid,
                type: line_items?.item_type,
                item: line_items?.item,
                model: line_items?.model,
                regularity: line_items?.frequency,
                start_month: line_items?.start_month ? moment(`01/${line_items?.start_month}/${line_items?.start_year}`) : '',
                end_month: line_items?.end_month ?  moment(`01/${line_items?.end_month}/${line_items?.end_year}`) : '',
                description: line_items?.description,
                discountChecked: line_items?.discount ? true : false,
                discount: line_items?.discount,
                qty: line_items?.quantity,
                rate: line_items?.rate,
                rateTaxChecked: line_items?.rate_tax ? true : false,
                rateTax: line_items?.rate_tax,
                total: line_items?.total,
                sh: line_items?.s_and_h,
                shTaxChecked: line_items?.s_and_h_tax ? true : false,
                shTax: line_items?.s_and_h_tax,
                coordinates : line_items?.coordinates,
                markers:this.getTotalForCoordinated(line_items)
              })
            }
            else if(line_items?.item_type === 'product'){
             
               
              itemsProduct.push({
                uuid: line_items?.uuid,
                type: line_items?.item_type,
                item: line_items?.item,
                model: line_items?.model,
                regularity: line_items?.frequency,
                start_month: line_items?.start_month ? moment(`01/${line_items?.start_month}/${line_items?.start_year}`) : '',
                end_month: line_items?.end_month ?  moment(`01/${line_items?.end_month}/${line_items?.end_year}`) : '',
                description: line_items?.description,
                discountChecked: line_items?.discount ? true : false,
                discount: line_items?.discount,
                qty: line_items?.quantity,
                rate: line_items?.rate,
                rateTaxChecked: line_items?.rate_tax ? true : false,
                rateTax: line_items?.rate_tax,
                total: line_items?.total,
                sh: line_items?.s_and_h,
                shTaxChecked: line_items?.s_and_h_tax ? true : false,
                shTax: line_items?.s_and_h_tax
              })
              
            }
          })
          tabs.push(
            {
              header_bag_price : obj?.header_bag_price,
              roll_bag_price:obj?.roll_bag_price,
              service_start_date:obj?.service_start_date,
              title: `PROPOSAL ${index + 1}`,
              uuid: obj?.uuid,
              items,
              itemsService,
              itemsProduct})
        })
      } else if (detail?.interested_products?.length > 0 || detail?.interested_services?.length > 0) {
        let items = []
        map(detail?.interested_products, (obj) => {
          items.push({
            type: 'product',
            item: obj,
            model: '',
            regularity: obj === 'pet_waste_station' ? '' : detail?.current_frequency,
            start_month: '',
            end_month: '',
            description: '',
            discountChecked: false,
            discount: '',
            qty: '',
            rate: '',
            rateTaxChecked: false,
            rateTax: '',
            total: '',
            sh: '',
            shTaxChecked: false,
            shTax: ''
          })
        })

        map(detail?.interested_services, (obj) => {
          items.push({
            type: 'service',
            item: obj,
            model: '',
            regularity: detail?.current_frequency,
            start_month: '',
            end_month: '',
            description: '',
            discountChecked: false,
            discount: '',
            qty: '',
            rate: '',
            rateTaxChecked: false,
            rateTax: '',
            total: '',
            sh: '',
            shTaxChecked: false,
            shTax: ''
          })
        })
        tabs.push({title: `PROPOSAL 1`, items})
      } else {
        const items = [{
          type: 'product',
          item: '',
          model: '',
          regularity: '',
          start_month: '',
          end_month: '',
          description: '',
          discountChecked: false,
          discount: '',
          qty: '',
          rate: '',
          rateTaxChecked: false,
          rateTax: '',
          total: '',
          sh: '',
          shTaxChecked: false,
          shTax: ''
        }]
        tabs.push({title: `PROPOSAL 1`, items})
      }

      // for multiple locations
      let markers = [];
      if (data?.multiple_locations && data?.multiple_locations !== 'None') {
        let locations = data?.multiple_locations?.split('MULTIPOINT')[1]
        locations = locations?.trim()?.substr(1, locations?.trim()?.length - 2)
        let temp = locations.split(', ')
        map(temp, (obj) => markers.push({lat: obj.split(' ')[0], lng: obj.split(' ')[1]}))
      } else if (!isEmpty(data?.commercial_quote?.address?.geo_location)) {
        markers = [{ lat: data?.commercial_quote?.address?.geo_location?.latitude, lng: data?.commercial_quote?.address?.geo_location?.longitude }]
      }
      ///-------------------------------
      let obj = {
        siteSurvey: data?.site_survey,
        workScope: data?.scope_of_work,
        mapNotes: data?.map_notes,
        coverLetter: data?.cover_letter ? {name: 'CoverLetter.pdf', imageUrl: data?.cover_letter, checked: true} : {},
        email_body: data?.email_body,
        to: data?.email_to,
        subject: data?.email_subject,
        email_signature: data?.email_signature,
        location: {pdf: data?.location_map, markers: markers},
        service_contract: data?.service_contract,
        close_reason: data?.close_reason,
        close_additional_info: data?.close_additional_info,
        currentStep: PROPOSAL_STATUS.indexOf(data?.proposal_status),
        proposal_due: data?.proposal_date ? data?.proposal_date : data?.commercial_quote?.proposal_due,
        org_markers: [...markers],
        business_development_officer: {officer_id: data?.business_development_officer}
      }
      tabs.length > 0 && this.setState({tabs});
      this.setState({ commercialProposalDetail: nextProps?.CommercialProposal?.getCommercialProposalDetail, ...obj, quoteDetail: detail, tabs, proposal_due: detail?.proposal_due, loader: true }, () => {
        // get BDA
        this.props.getBDA(detail?.field_office_uuid)
        this.getFieldOffice();
        // for active service
        if (isActivateService) {
          this.props.patchCommercialProposal(nextProps?.CommercialProposal?.getCommercialProposalDetail?.uuid, {proposal_status: 'service_activated', finalized_inner_proposal_uuid: tabs?.[currentTab]?.uuid})
        }
      });
    }

    // update commercial proposal detail
    if (Object.keys(nextProps?.CommercialProposal?.getProposalPdf).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.getProposalPdf) !== JSON.stringify(getProposalPdf)) {
      this.setState({ getProposalPdf: nextProps?.CommercialProposal?.getProposalPdf }, () => {
        if (isExportClick) {
          if (this.link) this.link.click()
        } else {
          window.open(nextProps?.CommercialProposal?.getProposalPdf)
        }
      });
    }

    // get BDA
    if (Object.keys(nextProps?.CommercialProposal?.bdaList).length > 0 &&
      JSON.stringify(nextProps?.CommercialProposal?.bdaList) !== JSON.stringify(this.props?.CommercialProposal?.bdaList)) {
      const {business_development_officer} = this.state;
      let bda = []
      if (!isEmpty(business_development_officer) && business_development_officer?.officer_id) {
        bda = nextProps?.CommercialProposal?.bdaList?.filter(x => x.officer_id === business_development_officer?.officer_id)?.[0]
      } else {
        bda = nextProps?.CommercialProposal?.bdaList?.[0]
      }
      this.setState({ bdaList: nextProps?.CommercialProposal?.bdaList, business_development_officer: bda});
    }
  }

  // add inner proposal
  addInnerProposal = () => {
    const {commercialProposalDetail, addCommercialProposal, tabs, isActivateService, isSendClick, isDuplicateClick, deletedInnerProposal, deletedLineItems} = this.state;
    const {updateInnerCommercialProposal, addInnerCommercialProposal, sendProposalMail, getProposalList, deleteInnerProposal, deleteProposalLineItems} = this.props;
    this.setState({loader: true})
    const arr = [];
    map(deletedLineItems, x => arr.push(deleteProposalLineItems(x)))
    map(deletedInnerProposal, x => arr.push(deleteInnerProposal(x)))
    map(tabs, (obj) => {
      const line_items = [];
      
      map(obj.itemsProduct, (item) => {
        let obj_item = {
          item_type: item?.type,
          item: item?.item,
          model: item?.model,
          frequency: item?.regularity,
          description: item?.description,
          discount: item?.discount || '0',
          quantity: item?.qty || '0',
          rate: item?.rate || '0',
          rate_tax: item?.rateTax || '0',
          s_and_h: item?.sh || '0',
          s_and_h_tax: item?.shTax || '0',
          total: item?.total || '0'
        }
        if (moment(item?.start_month).format('MMMM')) {
          Object.assign(obj_item, {start_month: item?.start_month ? moment(item?.start_month).format('MMMM').toLowerCase() : null,
            start_year: item?.start_month ? moment(item?.start_month).format('YYYY') : null})
        }

        if (moment(item?.end_month).format('MMMM')) {
          Object.assign(obj_item, {end_month: item?.end_month ? moment(item?.end_month).format('MMMM').toLowerCase() : null,
            end_year: item?.end_month ? moment(item?.end_month).format('YYYY') : null})
        }
        if (item.uuid && !isDuplicateClick) Object.assign(obj_item, {uuid: item.uuid})
        line_items.push(obj_item)
      }) // end of inner proposal line items

      map(obj.itemsService, (item) => {
        let obj_item = {
          item_type: item?.type,
          item: item?.item,
          model: item?.model,
          frequency: item?.regularity,
          description: item?.description,
          discount: item?.discount || '0',
          quantity: item?.qty || '0',
          rate: item?.rate || '0',
          rate_tax: item?.rateTax || '0',
          s_and_h: item?.sh || '0',
          s_and_h_tax: item?.shTax || '0',
          total: item?.total || '0',
          coordinates :item?.coordinates
        }
        if (moment(item?.start_month).format('MMMM')) {
          Object.assign(obj_item, {start_month: item?.start_month ? moment(item?.start_month).format('MMMM').toLowerCase() : null,
            start_year: item?.start_month ? moment(item?.start_month).format('YYYY') : null})
        }

        if (moment(item?.end_month).format('MMMM')) {
          Object.assign(obj_item, {end_month: item?.end_month ? moment(item?.end_month).format('MMMM').toLowerCase() : null,
            end_year: item?.end_month ? moment(item?.end_month).format('YYYY') : null})
        }
        if (item.uuid && !isDuplicateClick) Object.assign(obj_item, {uuid: item.uuid})
        line_items.push(obj_item)
      }) // end of inner proposal line items


      if (obj.uuid && !isDuplicateClick) {
        arr.push(
          updateInnerCommercialProposal(obj?.uuid, {
            proposal_uuid: commercialProposalDetail?.uuid,
            roll_bag_price: obj.roll_bag_price,
            header_bag_price: obj.header_bag_price,
            service_start_date:obj.service_start_date,
            line_items
          })
        )
      } else {
        arr.push(
          addInnerCommercialProposal({
            proposal_uuid: Object.keys(addCommercialProposal).length > 0 ? addCommercialProposal?.uuid : commercialProposalDetail?.uuid,
            roll_bag_price: obj.roll_bag_price,
            header_bag_price: obj.header_bag_price,
            service_start_date:obj.service_start_date,
            line_items
          })
        )
      }
    })

    Promise.all(arr).then((response) => {
      if (!isEmpty(response) && isEmpty(this.props?.CommercialProposal?.errors)) {
        this.setState({isDuplicateClick: false, loader: false})
        // for sending mail
        if (isSendClick) {
          sendProposalMail(addCommercialProposal?.uuid)
          this.setState({isSendClick: false})
        }

        if (isActivateService) {
          // getCommercialProposalById(addCommercialProposal?.uuid)
          this.setState({callActiveService: true}, () => this.onActiveService(this.props.isEdit ? commercialProposalDetail?.uuid : addCommercialProposal?.uuid))
        } else {
          this.setState({loader: true})
          getProposalList && getProposalList()
          message.success('Created Successfully')
          this.props.onChangeView(0)
        }
      } else {message.error('Something went wrong.')}
    }).catch(() => message.error('Something went wrong.'))
  }

  // get commercial proposal detail
  getCommercialProposalDetail = () => {
    const {isEdit, getCommercialProposalById, selectedProposal} = this.props;
    if (isEdit) {
      getCommercialProposalById(selectedProposal?.uuid)
    }
  }

  //Get roll and header bag price
  getFieldOffice = () => {
    const {quoteDetail} =this.state;

    this.props.editFieldOffice(quoteDetail.field_office_uuid);
  }

  // on step change
  onStepChange = (value) => {
    this.setState({currentStep: value})
    if (value === 3) {
      this.validate('active')
    } else {
      this.validate('edit')
    }
  }

  // on item row change
  onRowDataChangeProduct = (e, index, type) => {
    const {tabs, currentTab} = this.state;
    const value = type === 'bool' ? e.target.checked : e.target.value;
    const item = tabs[currentTab].itemsProduct[index]
    Object.assign(tabs[currentTab].itemsProduct[index], {[e.target.name]: value})
    const discount = parseFloat(item?.discount) !== 0 && item?.discount !== '' ? parseFloat(item?.discount) : 0;
    const per_idx = item?.rateTax?.indexOf('%');
    const org_rate_tax = item?.rateTaxChecked ? per_idx > -1 ? item?.rateTax?.replace('%', '') : item?.rateTax : 0;
    const rateTax = item?.rate * (parseFloat(org_rate_tax) / 100);
    const total = ((parseFloat(item?.qty) * parseFloat(item?.rate)) + rateTax + parseFloat(item?.sh)) - discount;
    Object.assign(tabs[currentTab].itemsProduct[index], {total})
    this.setState({tabs})
  }

    // on item row change
    onRowDataChangeService = (e, index, type) => {
      const {tabs, currentTab} = this.state;
      const value = type === 'bool' ? e.target.checked : e.target.value;
      const item = tabs[currentTab].itemsService[index]
      Object.assign(tabs[currentTab].itemsService[index], {[e.target.name]: value})
      const discount = parseFloat(item?.discount) !== 0 && item?.discount !== '' ? parseFloat(item?.discount) : 0;
      const per_idx = item?.rateTax?.indexOf('%');
      const org_rate_tax = item?.rateTaxChecked ? per_idx > -1 ? item?.rateTax?.replace('%', '') : item?.rateTax : 0;
      const rateTax = item?.rate * (parseFloat(org_rate_tax) / 100);
      const total = ((parseFloat(item?.qty) * parseFloat(item?.rate)) + rateTax ) - parseFloat(discount);
      Object.assign(tabs[currentTab].itemsService[index], {total})
      this.setState({tabs})
    }

  // on delete row
  onDeleteRowProduct = (index) => {
    const {tabs, currentTab, deletedLineItems} = this.state;
    if (tabs[currentTab].itemsProduct?.[index]?.uuid) deletedLineItems.push(tabs[currentTab].itemsProduct?.[index]?.uuid)
    tabs[currentTab].itemsProduct.splice(index, 1);

    this.setState({tabs})
  }

    // on delete row
    onDeleteRowService = (index) => {
      const {tabs, currentTab, deletedLineItems} = this.state;
      if (tabs[currentTab].itemsService?.[index]?.uuid) deletedLineItems.push(tabs[currentTab].itemsService?.[index]?.uuid)
      tabs[currentTab].itemsService.splice(index, 1);
  
      this.setState({tabs})
    }

  // on add tab
  onAddTab = () => {
    const {tabs} = this.state;
    this.getFieldOffice();
    tabs.push({
      title: `PROPOSAL ${tabs?.length + 1}`,
      header_bag_price:'',
      roll_bag_price:'',
      service_start_date :'',
      items: [{
        type: 'product',
        item: '',
        model: '',
        regularity: '',
        start_month: '',
        end_month: '',
        description: '',
        discountChecked: false,
        discount: '',
        qty: '',
        rate: '',
        rateTaxChecked: false,
        rateTax: '',
        total: '',
        sh: '',
        shTaxChecked: false,
        shTax: ''
      }],
      itemsService: [],
      itemsProduct: []
    })
    this.setState({tabs})
  }

  // remove tab
  onRemoveTab = (index) => {
    const {tabs, currentTab, deletedInnerProposal} = this.state;
    if (tabs[index]?.uuid) deletedInnerProposal.push(tabs[index]?.uuid)
    tabs.splice(index, 1)
    this.setState({tabs, currentTab: index === currentTab ? 0 : currentTab, errors: {}})
  }

  // on add item Product
  onAddItemProduct = () => {
    const {tabs, currentTab} = this.state;
    tabs[currentTab]["itemsProduct"].push({
      type: 'product',
      item: '',
      model: '',
      regularity: '',
      start_month: '',
      end_month: '',
      description: '',
      discountChecked: false,
      discount: 0,
      qty: 0,
      rate: 0,
      rateTaxChecked: false,
      rateTax: '',
      total: '',
      sh: 0,
      shTaxChecked: false,
      shTax: ''
    });
    this.setState({tabs})
  }

    // on add item
    onAddItemService = () => {
      const {tabs, currentTab} = this.state;
      tabs[currentTab]["itemsService"].push({
        type: 'service',
        item: '',
        model: '',
        regularity: '',
        start_month: '',
        end_month: '',
        description: '',
        discountChecked: false,
        discount: 0,
        qty: 0,
        rate: 0,
        rateTaxChecked: false,
        rateTax: '',
        total: '',
        sh: '',
        shTaxChecked: false,
        shTax: '',
        markers:[]
      });
      this.setState({tabs})
    }

  // on clear item
  onClearAllProduct = () => {
    const {tabs, currentTab, deletedLineItems} = this.state;

    if (!isEmpty(tabs)) {
      map(tabs[currentTab]["itemsProduct"], x => {
        if (x.uuid) deletedLineItems.push(x.uuid)
      })
    }
    tabs[currentTab || 0]["itemsProduct"] = [{      type: 'product',
      item: '',
      model: '',
      regularity: '',
      start_month: '',
      end_month: '',
      description: '',
      discountChecked: false,
      discount: 0,
      qty: 0,
      rate: 0,
      rateTaxChecked: false,
      rateTax: '',
      total: '',
      sh: 0,
      shTaxChecked: false,
      shTax: ''}];
    this.setState({tabs})
  }

    // on clear item
    onClearAllService = () => {
      const {tabs, currentTab, deletedLineItems} = this.state;
  
      if (!isEmpty(tabs)) {
        map(tabs[currentTab]["itemsService"], x => {
          if (x.uuid) deletedLineItems.push(x.uuid)
        })
      }
      tabs[currentTab || 0]["itemsService"] = [{type: 'service',
        item: '',
        model: '',
        regularity: '',
        start_month: '',
        end_month: '',
        description: '',
        discountChecked: false,
        discount: 0,
        qty: 0,
        rate: 0,
        rateTaxChecked: false,
        rateTax: '',
        total: '',
        sh: 0,
        shTaxChecked: false,
        shTax: '',
        coordinates: '',
        totalCoordinates: '',
        markers:[]}];
      this.setState({tabs})
    }

  // tab change
  tabChange = (e) => {
    this.setState({
      currentTab: e
    });
    const {tabs , currentTab, fieldOffice} = this.state;

    if(tabs[e].header_bag_price === '' && tabs[e].roll_bag_price === ''){

      tabs[e].header_bag_price = fieldOffice.data.community_card_header_bags;
      tabs[e].roll_bag_price = fieldOffice.data.commercial_roll_bags;
      this.setState({tabs});
    }
  };

  // toggle pdf preview
  togglePreview = (value) => {
    if (this.state.showPreview !== value) {
      this.setState({showPreview: value})
    }
  }

  // To toggle location modal
  toggleLocation = () => {
    this.setState((prevState) => ({ showLocation: !prevState.showLocation }))
  }

  // To toggle coordinate modal
  toggleCoordinates = (index) => {
    const {tabs , currentTab , coordinate} = this.state ; 
    let markers = tabs[currentTab].itemsService[index].markers;
    // coordinate = mark ;
    Object.assign(coordinate, {markers});
    this.setState({coordinate});
    //this.state.coordinateIndex = index;
    this.setState({ coordinateIndex : index});
    this.setState((prevState) => ({ showCoordinates: !prevState.showCoordinates }));
  }

  // To toggle close proposal modal
  toggleCloseProposal = () => {
    this.setState((prevState) => ({ isCloseProposal: !prevState.isCloseProposal }))
  }

  // To toggle activate proposal modal
  toggleActivateProposal = () => {
    this.setState((prevState) => ({ isActivateService: !prevState.isActivateService }))
  }

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on proposal detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // on Cover Letter Value Changed
  onCoverLetterValueChange = (e) => {
    const {coverLetter} = this.state;
    Object.assign(coverLetter,  { [e.target.name]: e.target.value })
    this.setState({coverLetter})
  }

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    console.warn('getBase64String calling...', file)
    const reader = new FileReader();
    console.warn('reader', reader);
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result);
    }
  };

  // on cover letter change
  onCoverLetterChange = (e) => {
    let {coverLetter} = this.state;
    const file = e?.file;
    if (file?.size > (5 * 1048576)) {
      message.error('File size should be less than 5MB');
    } else {
      file && this.getBase64String(file, (result) => {
        coverLetter = {name: file.name, imageUrl: result, checked: true};
        this.setState({coverLetter, is_cover_img: true})
      })
    }
  }

  // on remove cover letter
  onRemoveCoverLetter = () => {
    this.setState({coverLetter: {}, is_cover_img: true})
  }

  // clear mail box data
  onClearMailBox = () => {
    this.setState({to: '', subject: '', email_body: '', email_signature: '', errors: {}, mailErrors: {}})
  }

  generatePDF = () => {
    html2canvas(document.querySelector("#content")).then(() => {
      // document.body.appendChild(canvas)
    });
    const input = document.getElementById('content');
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = 250;
        const pageHeight = 280;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;
        const pdf = new jsPDF({
          orientation:"p",unit:"px"
        });
        let position = 15;
        pdf.addImage(imgData, 'PNG', 15, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position += heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 15, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        pdf.save('file.pdf');
      });
  }

  // on export button click
  onExportClick = (isExportClick = false) => {
    const {quoteDetail, currentTab, tabs} = this.state;
    this.setState({loader: true, isExportClick})
    this.props.getProposalPdf(quoteDetail?.uuid, {proposals__inner_proposals__uuid: tabs[currentTab]?.uuid})
  }

  // store drop pins
  onSaveMarkers = (markers) => {
    console.warn('onSaveMarkers calling...', markers)
    const {location} = this.state;
    Object.assign(location, {markers})
    this.setState({location, loader: true}, () => {
      this.setState({loader: false})
      if (!isEmpty(markers)) setTimeout(() => this.onSaveMapPDF(), 1500)
    })
  }

    // store drop pins
    onSaveMarkersCoordinates = (markers) => {
      console.warn('onSaveMarkers calling...', markers);
      
      let markerLength = markers.length;
      let coordString = "SRID=4326;MULTIPOINT("
      map(markers, (x , i) => {
      
        if(markerLength === i+1){
          coordString += x.lat + " " + x.lng +")";
        }else{
          coordString += x.lat + " " + x.lng +",";
        }
      });

      const {tabs, currentTab , coordinateIndex} = this.state; 
      if(markerLength > 0){
        tabs[currentTab].itemsService[coordinateIndex].coordinates = coordString ;
        tabs[currentTab].itemsService[coordinateIndex].totalCoordinates = markerLength ;
        tabs[currentTab].itemsService[coordinateIndex].markers = markers ;
      }
      else{
        tabs[currentTab].itemsService[coordinateIndex].coordinates = 0 ;
        tabs[currentTab].itemsService[coordinateIndex].totalCoordinates = markerLength ;
        tabs[currentTab].itemsService[coordinateIndex].markers = markers ;
      }
      this.setState({tabs});


    }

  // save map as pdf
  onSaveMapPDF = () => {
    this.setState({loader: true})
    const self = this;
    const input = document.querySelector('#org-map');
    console.warn('input', input);
    try {
      console.warn('1');
      const pdf = new jsPDF('p', 'pt', 'a4');
      console.warn('pdf', pdf)
      pdf.html(input, {
        callback: function(pdf) {
          console.warn('pdf', pdf);
          self.getBase64String(pdf.output('blob'), (result) => self.setState({loader: false, location: {...self.state.location, pdf: result}, is_location_pdf: true}))
          // pdf.save('Temp.pdf')
        }
      }) 
    } catch(e) {
      console.warn('error >>>', e);
    }
  }

  // validate required fields
  validate = (selectedAction) => {
    const {tabs} = this.state;
    const schema = yup.object().shape({
      tabs: yup.array(yup.object({
        service_start_date : yup.string().required("Service start date is required").nullable(),
        roll_bag_price : yup.string().required("Roll bag price is required").nullable(),
        header_bag_price : yup.string().required("header bag price is required").nullable(),
        checkLength :  yup.string().test('match', 'At least one proposal has no services or products added', function(checkLength) {
          if ((this.parent.itemsService.length + this.parent.itemsProduct.length) > 0) {
            return true
          } else {
            return checkLength 
          }
        }),  
        itemsService: yup.array(yup.object({
          // type: yup.string().required('Product/service is required'),
          item: yup.string().required('Item is required'),
          qty: yup.string().test("match", "Only integers are allow.", (qty) => {
            if (qty){
              return (/^[0-9\b]+$/).test(qty)
            }else{
              return false
            }
           
          }),
          rate: yup.string().test('match', 'Rate should be >0', (rate) => {
            return parseFloat(rate) > 0
          }),
          markers : yup.string().test("match","Coordinates are required.",function(markers) {
            if(markers === undefined){
              return false;
            }else{
              return true;
            }
            
          }),
          // model: yup.string().test('match', 'Model is required', function(model) {
          //   if (this.parent.type === 'product') return model
          //   return true
          // }),
          regularity: yup.string().test('match', 'Regularity is required', function(regularity) {
            if ((this.parent.item === 'pet_waste_stations' || this.parent.item === 'pet_waste_station_bags') && this.parent.model === 'mounted') {
              return true
            } else {
              return regularity 
            }
          }),
          total: yup.string().test('match', 'Total should be >0 and Digits in total not more than 6', function(total) {
            if(parseFloat(this.parent.qty) > 0 && parseFloat(this.parent.rate)>0){
              return true
            }else if(parseFloat(total) > 0 && parseFloat(total) <= 999999.9){
              return true
            }else{
              return false
            }
          })
        })),

        //Product
        itemsProduct: yup.array(yup.object({
        //  type: yup.string().required('Product/service is required'),
          item: yup.string().required('Item is required'),
          qty: yup.string().test("match", "Only integers are allow.", (qty) => {
            if (qty){
              return (/^[0-9\b]+$/).test(qty)
            }else{
              return false
            }
          }),
          rate: yup.string().test('match', 'Rate should be >0', (rate) => {
            return parseFloat(rate) > 0
          }),
          model: yup.string().test('match', 'Model is required', function(model) {
            if (this.parent.type === 'product'){
             
              if( this.parent.item === 'other'){
                return true;
              }else{
                return model;
              }
            } else{
              return true
            }
           
          }),
          sh : yup.string().required("S&H is required").nullable(),
          // regularity: yup.string().test('match', 'Regularity is required', function(regularity) {
          //   if ((this.parent.item === 'pet_waste_stations' || this.parent.item === 'pet_waste_station_bags') && this.parent.model === 'mounted') {
          //     return true
          //   } else {
          //     return regularity 
          //   }
          // }),
          total: yup.string().test('match', 'Total should be >0 and Digits in total not more than 6', function(total) {
            if(parseFloat(this.parent.qty) > 0 && parseFloat(this.parent.rate)>0){
              return true
            }else if(parseFloat(total) > 0 && parseFloat(total) <= 999999.9){
              return true
            }else{
              return false
            }
          })
        })),
      })),
    });

    const data = {tabs};
    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({btn_active: true, errors: {}, mailErrors: {}})
        this.callAction(selectedAction)
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})

        this.setState({errors: err_data, mailErrors: {}, btn_active: false,saveProposalSubmit : true})
      });
    }, 500)
  };  
  
  // validate required fields for mail
  validate_mail = (selectedAction) => {
    const {tabs, email_body, to, subject, email_signature} = this.state;
    const schema = yup.object().shape({
      tabs: yup.array(yup.object({
        items: yup.array(yup.object({
          type: yup.string().required('Product/service is required'),
          item: yup.string().required('Item is required'),
          qty: yup.string().test("match", "Only integers are allow.", (qty) => {
            // if (qty && (/\b(?<!\.)\d+(?!\.)\b/).test(qty)) return qty
            if (qty && (/^[0-9\b]+$/).test(qty)) return qty
            return true
          }),
          rate: yup.string().test('match', 'Rate should be >0', (rate) => {
            return parseFloat(rate) > 0
          }),
          model: yup.string().test('match', 'Model is required', function(model) {
            if (this.parent.type === 'product') return model
            return true
          }),
          regularity: yup.string().test('match', 'Regularity is required', function(regularity) {
            if ((this.parent.item === 'pet_waste_stations' || this.parent.item === 'pet_waste_station_bags') && this.parent.model === 'mounted') {
              return true
            } else {
              return regularity
            }
          }),
          start_month: yup.string().test('match', 'Start month is required', function(start_month) {
            const {item, model} = this.parent;
            if ((item === 'pet_waste_stations' || item === 'pet_waste_station_bags') && model === 'mounted') {
              return true
            } else {
              return start_month
            }
          }).nullable(),
          end_month: yup.string().test('match', 'Invalid end month', function(end_month) {
            const {item, model} = this.parent;
            if ((item === 'pet_waste_stations' || item === 'pet_waste_station_bags') && model === 'mounted') {
              return true
            } else if (!moment(end_month).isBefore(this.parent.start_month, 'day')) {
              return !moment(end_month).isBefore(this.parent.start_month, 'day')
            }
          }).nullable(),
          total: yup.string().test('match', 'Total should be >0 and Digits in total not more than 6', (total) => {
            return (parseFloat(total) > 0 && parseFloat(total) <= 999999.9)
          })
        })).required('Atleast one line item should be present'),
      })),
      email_body: yup.string().required('Email body is required'),
      to: yup.string().required('To is required').email('Invalid email'),
      subject: yup.string().required('Subject is required'),
      email_signature: yup.string().required('Email signature is required')
    });

    const data = {tabs,  email_body, to, subject, email_signature};

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({btn_active: true, errors: {}, mailErrors: {}})
        
        // call action
        if (selectedAction === 'send') {
          this.setState({showConfirmation: true, isSendClick: true})
        } else if (selectedAction === 'save_update') {
          this.setState({showConfirmation: true})
        }
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message})
        this.setState({errors: {}, mailErrors: err_data, btn_active: false})
      });
    }, 500)
  };

  //call action
  callAction = (selectedAction) => {
    if (selectedAction === 'active') {
      this.toggleActivateProposal()
    } else if (selectedAction === 'edit') {
      this.onUpdateProposal()
    } else if (selectedAction === 'save') {
      this.setState({currentStep: 0});
      this.onSaveProposal()
    } else if (selectedAction === 'duplicate') {
      this.setState({isDuplicateClick: true}, () => this.onSaveProposal())
    } else if (selectedAction === 'export') {
      this.onExportClick(true)
    } else if (selectedAction === 'print') {
      this.onExportClick(false)
    }
  }

  // on Cancel
  onCancel = () => {
    //this.onClearAll()
    this.props.onChangeView(0)
  }

  // on Save proposal
  onSaveProposal = (service_contract = '') => {
    const { addCommercialProposal } = this.props;
    const { quoteDetail, siteSurvey, workScope, mapNotes, email_body, currentStep, subject, to, location, coverLetter,
      email_signature, proposal_due, is_cover_img, is_location_pdf, business_development_officer } = this.state;
    let location_str = '',service_contract_url = '';
    this.setState({loader: true})
    if (!isEmpty(service_contract)) {
      const arr = service_contract?.imageUrl?.split(';')
      service_contract_url = arr[0] + `;df:${service_contract?.name?.replace('.pdf', '')};` + arr[1]
    }
    map(location?.markers, (obj, index) => location_str += `${obj.lat} ${obj.lng} ${location?.markers?.length - 1 !== index ? ', ' : ''}`)
    let obj = {
      user_uuid: quoteDetail?.user_uuid,
      commercial_quote_uuid: quoteDetail.uuid,
      commercial_quote: {
        proposal_due: proposal_due ? moment(proposal_due).format('YYYY-MM-DD') : null
      },
      proposal_status: PROPOSAL_STATUS[currentStep],
      site_survey: siteSurvey,
      scope_of_work: workScope,
      map_notes: mapNotes,
      email_subject: subject,
      email_to: to,
      email_body: email_body,
      email_signature,
      // cover_letter: "",
      service_contract: service_contract_url,
      proposal_date: proposal_due ? moment(proposal_due).format('YYYY-MM-DD') : null,
      multiple_locations: location_str ? `SRID=4326;MULTIPOINT (${location_str})` : null,
      business_development_officer: business_development_officer?.officer_id || null
    }
    if (coverLetter?.imageUrl && is_cover_img) {
      const arr = coverLetter?.imageUrl?.split(';')
      const imageUrl = arr[0] + `;df:${coverLetter?.name?.replace('.pdf', '')};` + arr[1]
      Object.assign(obj, {cover_letter: imageUrl})
    }
    if (location?.pdf && is_location_pdf) {
      Object.assign(obj, {location_map: location?.pdf})
    }
    addCommercialProposal(obj)
    message.success('Proposal saved successfully.', 20);
  }

  // on Update proposal
  onUpdateProposal = (service_contract = '') => {
    const { patchCommercialProposal } = this.props;
    const { quoteDetail, siteSurvey, workScope, mapNotes, email_body, currentStep, subject, to, location, coverLetter,
      commercialProposalDetail, email_signature, proposal_due, is_cover_img, is_location_pdf, business_development_officer } = this.state;
    this.setState({loader: true, callInnerProposal: true, isUpdateClick: true})
    let location_str = '', service_contract_url = '';
    map(location?.markers, (obj, index) => location_str += `${obj.lat} ${obj.lng} ${location?.markers?.length - 1 !== index ? ', ' : ''}`)
    if (!isEmpty(service_contract)) {
      const arr = service_contract?.imageUrl?.split(';')
      service_contract_url = arr[0] + `;df:${service_contract?.name?.replace('.pdf', '')};` + arr[1]
    }

    let obj = {
      user_uuid: commercialProposalDetail?.user_uuid,
      commercial_quote_uuid: quoteDetail.uuid,
      commercial_quote: {
        proposal_due: proposal_due ? moment(proposal_due).format('YYYY-MM-DD') : null
      },
      proposal_status: PROPOSAL_STATUS[currentStep === 3 ? 2 : currentStep],
      site_survey: siteSurvey,
      scope_of_work: workScope,
      map_notes: mapNotes,
      email_subject: subject,
      email_to: to,
      email_body: email_body,
      email_signature: email_signature,
      // cover_letter: "",
      service_contract: service_contract_url,
      proposal_date: proposal_due ? moment(proposal_due).format('YYYY-MM-DD') : null,
      multiple_locations: location_str ? `SRID=4326;MULTIPOINT (${location_str})` : null,
      business_development_officer: business_development_officer?.officer_id || null
    }
    if (coverLetter?.imageUrl && is_cover_img) {
      const arr = coverLetter?.imageUrl?.split(';')
      const imageUrl = arr[0] + `;df:${coverLetter?.name?.replace('.pdf', '')};` + arr[1]
      Object.assign(obj, {cover_letter: imageUrl})
    }
    if (location?.pdf && is_location_pdf) {
      Object.assign(obj, {location_map: location?.pdf})
    }
    patchCommercialProposal(commercialProposalDetail?.uuid, obj);
    message.success('Proposal updated successfully.', 20);
  }

  // on active service
  onActiveService = () => {
    const {patchCommercialProposal} = this.props;
    const {commercialProposalDetail, tabs, currentTab} = this.state;
    this.setState({loader: true, callInnerProposal: false})
    // let service_contract_url = '';
    // if (!isEmpty(service_contract)) {
    //   const arr = service_contract?.imageUrl?.split(';')
    //   service_contract_url = arr[0] + `;df:${service_contract?.name?.replace('.pdf', '')};` + arr[1]
    // }
    patchCommercialProposal(commercialProposalDetail?.uuid, {proposal_status: 'service_activated', finalized_inner_proposal_uuid: tabs?.[currentTab || 0]?.uuid})
    message.success('Proposal converted to customer.')
    // setTimeout(() => this.props.history.replace('/commercial'), 1000)
  }

  // on save mail
  onSaveMail = () => {
    const {email_body, subject, to, email_signature, commercialProposalDetail, coverLetter, is_cover_img} = this.state;
    const {patchCommercialProposal} = this.props;

    if (commercialProposalDetail?.uuid) {
      this.setState({loader: true, callInnerProposal: false, isUpdateClick: true})
      let obj = {
        email_subject: subject,
        email_to: to,
        email_body: email_body,
        // cover_letter: "",
        email_signature: email_signature,
      }
      if (coverLetter?.imageUrl && is_cover_img) {
        const arr = coverLetter?.imageUrl?.split(';')
        const imageUrl = arr[0] + `;df:${coverLetter?.name?.replace('.pdf', '')};` + arr[1]
        Object.assign(obj, {cover_letter: imageUrl})
      }

      patchCommercialProposal(commercialProposalDetail?.uuid, obj)

      patchCommercialProposal(commercialProposalDetail?.uuid, obj)
      setTimeout(() => this.setState({showConfirmation: false}, () => this.getCommercialProposalDetail()), 1500)
    } else {
      this.onSaveProposal()
    }
  }

  // deactivate proposal
  onDeactivateProposal = () => {
    const { patchCommercialProposal,onChangeView } = this.props
    const {commercialProposalDetail} = this.state;
    this.setState({callInnerProposal: false})
    patchCommercialProposal(commercialProposalDetail?.uuid, {
      proposal_status: 'closed',
      close_reason: 'Deactive Proposal',
      close_additional_info: 'Deactive Proposal'
    })

    setTimeout(() => {onChangeView(0); this.props.getProposalList()}, 1000)
  }

  //render cover letter upload
  renderUpload = () => {
    const {coverLetter} = this.state;
    let file_name = '';
    if (coverLetter?.imageUrl?.includes('https:')) {
      let url = coverLetter?.imageUrl?.split('?') || [];
      file_name = url?.[0]?.split('/')?.[url?.[0]?.split('/')?.length - 1]
    }
    return (
      <React.Fragment>
        <b className="mb-10 d-block">Cover Letter</b>
        <div className={'flex row-reverse'}>
          <div className={'cover-letters flex-1'}>
            {
              !isEmpty(coverLetter) ?
                <div className={'flex cvrow'} style={{"maxWidth": "100%"}}>
                  <div className="inline-check-list sm-checks">
                    <div className="fitem-check">
                      <input
                        type="checkbox"
                        className="fitem-ck-input"
                        id="letterChecked"
                        name="checked"
                        checked={coverLetter?.checked}
                        onChange={(e) => this.onCoverLetterValueChange({target: {name: 'checked', value: e.target.checked}})} />
                      <label htmlFor={'letterChecked'} className="fitem-ck-txt"/>
                    </div>
                  </div>
                  <figure>
                    <FilePdfOutlined className="fileprev" style={{height: 55, width: 50}}/>
                  </figure>
                  <div className="filedetail">
                    <h4>{file_name || coverLetter?.name}</h4>
                    <span className="action-link">
                      <a href="/#" onClick={(e) => {e.preventDefault(); this.togglePreview(true)}}><u>{'Preview'}</u></a> <a download={coverLetter.name} href={coverLetter.imageUrl} rel="noopener noreferrer" target={"_blank"} title='Download pdf document'><u>{'Download'}</u></a> 
                      <Popconfirm
                        title="Are you sure?"
                        onConfirm={() => this.onRemoveCoverLetter()}
                        okText="Yes"
                        cancelText="No"
                        overlayClassName={'popup-width'}
                      >
                        <a className={'danger'} href={'/#'} onClick={(e) => {e.preventDefault();  }} title='Delete pdf document'><u>{'Delete'}</u></a>
                      </Popconfirm>
                    </span>
                  </div>
                </div> : ''
            }
          </div>
          <div className="flex cvrow upld-wrap">
            <Upload
              name={'file'}
              accept=".pdf,application/pdf"
              beforeUpload={() => false}
              showUploadList={false}
              className="avatar-uploader"
              onChange={this.onCoverLetterChange}>
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p>Drag and drop your cover letter or click here to upload</p>
            </Upload>
          </div>
        </div>
      </React.Fragment>
    )
  }

  // render steps
  renderSteps = () => {
    const {commercialProposalDetail} = this.state;
    const {isEdit} = this.props;

    const competeSurvey = commercialProposalDetail?.status_logs?.find(x => x.status === 'survey_complete')
    const proposalSubmitted = commercialProposalDetail?.status_logs?.find(x => x.status === 'proposal_submitted')

    let currentStep = 0;
    if (isEmpty(commercialProposalDetail?.status_logs)) currentStep = 0
    if (!isEmpty(competeSurvey)) currentStep = 1
    if (!isEmpty(proposalSubmitted)) currentStep = 2

    return (
      <div>
        <Steps
          size="small"
          current={currentStep}
          onChange={(current) => isEdit && this.onStepChange(current)}
          className="site-navigation-steps main-nav"
        >
          <Step className="current" title="Inquiry Received" style={{"backgroundColor": currentStep >= 0 ? "#F6CD31" : ""}} />
          <Step className="green" title="Completed Site Survey" style={{"backgroundColor": currentStep >= 1 ? "#ED9B16" : ""}} />
          <Step className="red" title="Submitted Proposal" style={{"backgroundColor": currentStep >= 2 ? "#ABC318" : ""}} />
          <Step className="grey" title="Lose/Won" style={{"backgroundColor": currentStep >= 3 ? "#ABC318" : ""}} />
        </Steps>
        <div className={"flex flex-start"}>
          {currentStep >= 0 ? <div className={"flex-1 txt-blck"}>
            <span className="d-block">{moment().format('MMM DD, YYYY')}</span>
            <span>{`Website Signup Form`}</span>
          </div> : <div />}
          {currentStep >= 1 ? <div className={"flex-1 txt-blck"}>
            <span className="d-block">{`Contacted ${moment(competeSurvey?.created_at).format('MMM DD, YYYY')}\nby ${competeSurvey?.contacted_user?.first_name || ''}`}</span>
          </div> : <div /> }
          {currentStep >= 2 ? <div className={"flex-1 txt-blck"}>
            <span className="d-block">{`Contacted ${moment(proposalSubmitted?.created_at).format('MMM DD, YYYY')}\nby ${proposalSubmitted?.contacted_user?.first_name || ''}`}</span>
          </div> : <div />}
          <div className="flex-1 txt-blck">
            {(isEdit && currentStep === 0) ? <button className="btn" onClick={() => this.onStepChange(1)}>Moved to Site Survey</button> : ''}
            {(isEdit && currentStep === 1) ? <button className="btn" onClick={() => this.onStepChange(2)}>Moved to Proposal</button> : ''}
            {(isEdit && currentStep === 2) ? <button className={`btn btn-primary`} onClick={() => this.onStepChange(3)}>Activate Service</button> : ''}
          </div>
        </div>

        {currentStep >= 3 ? <span>{''}</span> : <div />}
        {isEdit ? <span className="success mt-10"><b>if this user no longer interested, <a href="/#" onClick={(e) => {e.preventDefault(); this.onDeactivateProposal()}}><u>{'Deactivate Proposal'}</u></a></b></span> : ''}
      </div>
    )
  }

  // render basic detail
  renderBasicDetails = () => {
    const {proposal_due, quoteDetail, business_development_officer} = this.state;
    return (
      <div>
        <div className={'flex'}>
          <div className={'flex-1'}>
            <b>Business Development Assignee</b>
            <div className="mt-10"><Avatar /> {business_development_officer?.name || ''}</div>
          </div>
          <div className="flex-1 fitem half-fitem">
            <b className="mb-10">Proposal Date</b>
            <DatePicker
              inputReadOnly
              style={{ 'width': '100%' }}
              name='proposal_due'
              format="MM/DD/YYYY"
              allowClear={false}
              value={proposal_due ? moment(proposal_due) : null}
              onChange={(e) => this.onTextChange({target: {name: 'proposal_due', value: e}})}
            />
          </div>
        </div>
        <hr/>
        <div className={'pdetails mb-0'}>
          <div className={'pcell'}>
            <div>
              <b>HOA</b>
              <p className="wrap">{quoteDetail?.community_name || ''}</p>
            </div>
            <div>
              <b>Management Company</b>
              <p className="wrap mb-0">{quoteDetail?.management_company || ''}</p>
            </div>
          </div>
          <div className={'pcell'}>
            <div>
              <b>Email</b>
              <p className="mb-20 wrap">{quoteDetail?.email_address || ''}</p>
            </div>
            <div>
              <b>Address (Service)</b>
              <p className="wrap mb-0">{quoteDetail?.address ? `${quoteDetail?.address?.address} ${quoteDetail?.address?.city} ${quoteDetail?.address?.state}, ${quoteDetail?.address?.zip_code}` : ''}</p>
            </div>
          </div>
          <div className={'pcell'}>
            <div>
              <b>Community Manager</b>
              <p className="mb-20 wrap">{quoteDetail?.first_name ? `${quoteDetail?.first_name} ${quoteDetail?.last_name}` : ''}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // render Item Row
  renderItemRowProduct = (item ,index ) => {
    
    const {errors, currentTab, mailErrors} = this.state;

    const itemArr = item.type === 'product' ? PRODUCTS : item.type === 'service' ? SERVICES : [];
    //  const itemArr = type === 'Product' ? PRODUCTS : type === 'Service' ? SERVICES : [];
    return (
      <div className={'tbl-body form-group'} key={`items${index}`}>


        <div className={"fitem tbl-cell item"}>
          <Select
            showArrow
            name={'item'}
            dropdownClassName="sm-filter"
            virtual={false}
            style={{ width: '100%' }}
            value={item?.item ?item?.item : undefined}
            placeholder={'Item'}
            
            onChange={(e) => this.onRowDataChangeProduct({target: {name: 'item', value: e}}, index)}
          >
            {map(itemArr, (obj) => <Option value={obj.value} key={obj.value}>{obj.key}</Option>) }
          </Select>
          {(errors?.[`tabs[${currentTab}].itemsProduct[${index}].item`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].item`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].itemsProduct[${index}].item`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].item`]}</label> : ''}
        </div>

        {item.type === 'product' ?
          <div className={"fitem tbl-cell model"}>
            <Select
              showArrow
              name={'model'}
              dropdownClassName="sm-filter"
              virtual={false}
              style={{ width: '100%' }}
              disabled ={item?.item === "other" ? true :false}
              value={(item?.model  && item?.item !== "other") ? item?.model : undefined}
              placeholder={'Model'}
              onChange={(e) => this.onRowDataChangeProduct({target: {name: 'model', value: e}}, index)}
            >
              <Option value="mounted">Mounted</Option>
              <Option value="header_bags">Header Bags</Option>
            </Select>
            {(errors?.[`tabs[${currentTab}].itemsProduct[${index}].model`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].model`]) ?
              <label className="new_err_msg"><i className="las la-info-circle"/>
                {errors?.[`tabs[${currentTab}].itemsProduct[${index}].model`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].model`]}</label> : ''}
          </div> : ''
        }

     
    
        {item.type === 'service' ?
          <div className="fitem tbl-cell reg">
            <div className={"fitem"}>
              <Select
                showArrow
                name={'regularity'}
                virtual={false}
                style={{width: '100%'}}
                value={item?.regularity ? item?.regularity : undefined}
                placeholder={'Regularity'}
                onChange={(e) => this.onRowDataChangeProduct({target: {name: 'regularity', value: e}}, index)}
              >
                {map(FREQUENCY_MAPPING, (obj) => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)}
              </Select>
              {(errors?.[`tabs[${currentTab}].itemsProduct[${index}].regularity`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].regularity`]) ?
                <label className="new_err_msg"><i className="las la-info-circle"/>
                  {errors?.[`tabs[${currentTab}].itemsProduct[${index}].regularity`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].regularity`]}</label> : ''}
            </div> 
            
            

            {(errors?.[`tabs[${currentTab}].items[${index}].start_month`] || mailErrors?.[`tabs[${currentTab}].items[${index}].start_month`]) ?
              <label className="new_err_msg"><i className="las la-info-circle"/>
                {errors?.[`tabs[${currentTab}].items[${index}].start_month`] || mailErrors?.[`tabs[${currentTab}].items[${index}].start_month`]}</label> : ''}
            {(errors?.[`tabs[${currentTab}].items[${index}].end_month`] || mailErrors?.[`tabs[${currentTab}].items[${index}].end_month`]) ?
              <label className="new_err_msg"><i className="las la-info-circle"/>
                {errors?.[`tabs[${currentTab}].items[${index}].end_month`] || mailErrors?.[`tabs[${currentTab}].items[${index}].end_month`]}</label> : ''}
          </div>
          :''}
        


        <div className="fitem tbl-cell desc frm-ctrl">
          <textarea
            rows="4"
            className="bdr-control"
            name="description"
            placeholder={"Add you description here"}
            value={item?.description}
            onChange={(e) => this.onRowDataChangeProduct(e, index)} />
        </div>

       

        <div className={'fitem tbl-cell qty frm-ctrl'}>
          <input
            type="text"
            className="bdr-control"
            value={item?.qty}
            name="qty"
            onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChangeProduct(e, index) }
            placeholder="QTY" />
          {(errors?.[`tabs[${currentTab}].itemsProduct[${index}].qty`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].qty`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].itemsProduct[${index}].qty`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].qty`]}</label> : ''}
        </div>

        <div className={'flex tbl-cell disc frm-ctrl'}>         
          <div className={'fitem position-relative'}>
            <CurrencyFormat 
              value={item?.discount} 
              thousandSeparator={true} 
              prefix={'$'}
              decimalSeparator={"."}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              placeholder={"$ 0.00"}
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                let e ={target : {value:value , name:"discount"}  }
                this.onRowDataChangeProduct(e, index,"text")
              }}/>
          </div>
          
        </div>

        <div className="fitem tbl-cell ratee frm-ctrl">
          <div className={'fitem position-relative'}>
            <CurrencyFormat 
              value={item?.rate} 
              thousandSeparator={true} 
              prefix={'$'}
              decimalSeparator={"."}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              placeholder={"$ 0.00"}
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                let e ={target : {value:value , name:"rate"}  }
                this.onRowDataChangeProduct(e, index,"text")
              }}/>
            {(errors?.[`tabs[${currentTab}].itemsProduct[${index}].rate`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].rate`]) ?
              <label className="new_err_msg"><i className="las la-info-circle"/>
                {errors?.[`tabs[${currentTab}].itemsProduct[${index}].rate`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].rate`]}</label> : ''}
          </div>


        </div>

        { 
          item.type === 'product' ?
            <div className="fitem tbl-cell sh frm-ctrl"> {/*rate*/}
              <div className={'fitem position-relative'}>
                <CurrencyFormat 
                  value={item?.sh} 
                  thousandSeparator={true} 
                  prefix={'$'}
                  decimalSeparator={"."}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  allowNegative={false}
                  placeholder={"$ 0.00"}
                  onValueChange={(values) => {
                    const { formattedValue, value } = values;
                    let e ={target : {value:value , name:"sh"}  }
                    this.onRowDataChangeProduct(e, index,"text")
                  }}/>
                  
                {(errors?.[`tabs[${currentTab}].itemsProduct[${index}].sh`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].sh`]) ?
                  <label className="new_err_msg"><i className="las la-info-circle"/>
                    {errors?.[`tabs[${currentTab}].itemsProduct[${index}].sh`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].sh`]}</label> : ''}
              </div>

         
            </div> : ''
        }

        <div className="fitem tbl-cell ttl">
          <label>${item?.total ? formatToCurrency(item?.total) : '0.00'}</label>
          {(errors?.[`tabs[${currentTab}].itemsProduct[${index}].total`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].total`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].itemsProduct[${index}].total`] || mailErrors?.[`tabs[${currentTab}].itemsProduct[${index}].total`]}</label> : ''}
        </div>
        <div className="tbl-cell ant-ico-del">
          <DeleteFilled onClick={() => this.onDeleteRowProduct(index)}/>
        </div>
      </div>
    )
  }

  renderItemRowService = (item ,index ) => {
    
    const {errors, currentTab, mailErrors} = this.state;
    const itemArr = item.type === 'product' ? PRODUCTS : item.type === 'service' ? SERVICES : [];

    //  const itemArr = type === 'Product' ? PRODUCTS : type === 'Service' ? SERVICES : [];
    return (
      <div className={'tbl-body form-group'} key={`items${index}`}>


        <div className={"fitem tbl-cell item"}>
          <Select
            showArrow
            name={'item'}
            dropdownClassName="sm-filter"
            virtual={false}
            style={{ width: '100%' }}
            value={item?.item ?item?.item : undefined}
            placeholder={'Item'}
            onChange={(e) => this.onRowDataChangeService({target: {name: 'item', value: e}}, index)}
          >
            {map(itemArr, (obj) => <Option value={obj.value} key={obj.value}>{obj.key}</Option>) }
          </Select>
          {(errors?.[`tabs[${currentTab}].itemsService[${index}].item`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].item`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].itemsService[${index}].item`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].item`]}</label> : ''}
        </div>

        {item.type === 'product' ?
          <div className={"fitem tbl-cell model"}>
            <Select
              showArrow
              name={'model'}
              dropdownClassName="sm-filter"
              virtual={false}
              style={{ width: '100%' }}
              value={item?.model ? item?.model : undefined}
              placeholder={'Model'}
              onChange={(e) => this.onRowDataChangeService({target: {name: 'model', value: e}}, index)}
            >
              <Option value="mounted">Mounted</Option>
              <Option value="header_bags">Header Bags</Option>
            </Select>
            {(errors?.[`tabs[${currentTab}].itemsService[${index}].model`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].model`]) ?
              <label className="new_err_msg"><i className="las la-info-circle"/>
                {errors?.[`tabs[${currentTab}].itemsService[${index}].model`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].model`]}</label> : ''}
          </div> : ''
        }

     
    
        {item.type === 'service' ?
          <div className="fitem tbl-cell reg">
            <div className={"fitem"}>
              <Select
                showArrow
                name={'regularity'}
                virtual={false}
                style={{width: '100%'}}
                value={item?.regularity ? item?.regularity : undefined}
                placeholder={'Frequency'}
                onChange={(e) => this.onRowDataChangeService({target: {name: 'regularity', value: e}}, index)}
              >
                {map(FREQUENCY_MAPPING, (obj) => <Option value={obj.value} key={obj.value}>{obj.key}</Option>)}
              </Select>
              {(errors?.[`tabs[${currentTab}].itemsService[${index}].regularity`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].regularity`]) ?
                <label className="new_err_msg"><i className="las la-info-circle"/>
                  {errors?.[`tabs[${currentTab}].itemsService[${index}].regularity`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].regularity`]}</label> : ''}
            </div> 
            
  
            {(errors?.[`tabs[${currentTab}].items[${index}].start_month`] || mailErrors?.[`tabs[${currentTab}].items[${index}].start_month`]) ?
              <label className="new_err_msg"><i className="las la-info-circle"/>
                {errors?.[`tabs[${currentTab}].items[${index}].start_month`] || mailErrors?.[`tabs[${currentTab}].items[${index}].start_month`]}</label> : ''}
            {(errors?.[`tabs[${currentTab}].items[${index}].end_month`] || mailErrors?.[`tabs[${currentTab}].items[${index}].end_month`]) ?
              <label className="new_err_msg"><i className="las la-info-circle"/>
                {errors?.[`tabs[${currentTab}].items[${index}].end_month`] || mailErrors?.[`tabs[${currentTab}].items[${index}].end_month`]}</label> : ''}
          </div>
          :''}
        


        <div className="fitem tbl-cell desc frm-ctrl">
          <textarea
            rows="4"
            className="bdr-control"
            name="description"
            placeholder={"Add you description here"}
            value={item?.description}
            onChange={(e) => this.onRowDataChangeService(e, index)} />
        </div>

       

        <div className={'fitem tbl-cell qty frm-ctrl'}>
          <input
            type="text"
            className="bdr-control"
            value={item?.qty}
            name="qty"
            onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChangeService(e, index) }
            placeholder="QTY" />
          {(errors?.[`tabs[${currentTab}].itemsService[${index}].qty`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].qty`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].itemsService[${index}].qty`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].qty`]}</label> : ''}
        </div>

        <div className={'fitem tbl-cell cord frm-ctrl'}>
          <div className="position-relative">
            <input
              type="text"
              className="bdr-control"
              value={item?.markers?.length}
              name="coordinates"
              //onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChangeService(e, index) }
              placeholder="Coordinates" />
            <button type="button" className="opacity-5" onClick={() => this.toggleCoordinates(index)}><PlusCircleOutlined/>&nbsp;&nbsp;Add</button>
          </div>
          {(errors?.[`tabs[${currentTab}].itemsService[${index}].markers`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].markers`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].itemsService[${index}].markers`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].markers`]}</label> : ''}
        </div>

        <div className={'flex tbl-cell disc frm-ctrl'}>
          <div className={'fitem position-relative'}>
            <CurrencyFormat 
              value={item?.discount} 
              thousandSeparator={true} 
              prefix={'$'}
              decimalSeparator={"."}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              placeholder={"$ 0.00"}
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                let e ={target : {value:value , name:"discount"}  }
                this.onRowDataChangeService(e, index,"text")
              }}/>
          </div>
        </div>

        <div className="fitem tbl-cell ratee frm-ctrl">
          <div className={'fitem position-relative'}>
            <CurrencyFormat 
              value={item?.rate} 
              thousandSeparator={true} 
              prefix={'$'}
              decimalSeparator={"."}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={false}
              placeholder={"$ 0.00"}
              onValueChange={(values) => {
                const { formattedValue, value } = values;
                let e ={target : {value:value , name:"rate"}  }
                this.onRowDataChangeService(e, index,"text")
              }}/>
            {(errors?.[`tabs[${currentTab}].itemsService[${index}].rate`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].rate`]) ?
              <label className="new_err_msg"><i className="las la-info-circle"/>
                {errors?.[`tabs[${currentTab}].itemsService[${index}].rate`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].rate`]}</label> : ''}
          </div>


        </div>

        {
          item.type === 'product' ?
            <div className="fitem tbl-cell sh frm-ctrl"> {/*rate*/}
              <div className={'fitem'}>
                <input
                  type="text"
                  value={item?.sh}
                  name="sh"
                  className="bdr-control"
                  onChange={(e) => this.onNumericInputChange(e.target.value) && this.onRowDataChangeService(e, index) }
                  placeholder="sh" />
              </div>

            </div> : ''
        }

        <div className="fitem tbl-cell ttl">
          <label>${item?.total ? formatToCurrency(item?.total) : '0.00'}</label>
          {(errors?.[`tabs[${currentTab}].itemsService[${index}].total`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].total`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].itemsService[${index}].total`] || mailErrors?.[`tabs[${currentTab}].itemsService[${index}].total`]}</label> : ''}
        </div>
        <div className="tbl-cell ant-ico-del">
          <DeleteFilled onClick={() => this.onDeleteRowService(index)}/>
        </div>
      </div>
    )
  }

  getTotalForCoordinated(item){
    const {tabs , currentTab , } = this.state;
    if(item?.uuid !== undefined){

      var _markers = [], multiple_locations = item?.coordinates;
      let locations = multiple_locations?.split('MULTIPOINT')[1];
      locations = locations?.trim().substr(1, locations.trim().length - 2);
      //locations = locations?.trim().substr(1, locations.trim().length - 2);
      let temp = locations?.split(', ');
      map(temp, (obj) => _markers.push({lat: obj.split(' ')[0], lng: obj.split(' ')[1]}));
    }
    return _markers;
  }


  // render table
  renderItemTable = () => {
    const {tabs, currentTab, errors, mailErrors ,saveProposalSubmit} = this.state;
    const items = tabs?.[currentTab]?.['items'];
    const productItems = tabs?.[currentTab]?.['itemsProduct'];
    const serviceItems = tabs?.[currentTab]?.['itemsService'];

   
    return (
      <React.Fragment>
        { (saveProposalSubmit ?  (errors?.[`tabs[${currentTab}].checkLength`] ? (message.error("At least one proposal has no services or products added")) && this.setState({saveProposalSubmit:false}) :''):"") }
            
        <div className="form-group px-20 ">
            
          <div className="half-fitem fitem col-6">
            <div className="half-fitem fitem">
              <label>Service Start Date <sup>*</sup></label>
              <DatePicker
                allowClear={false}
                format="MMM DD,YYYY"
                style={{ width: '100%' }}
                onChange={(e) => this.onChangeStartDate(e)}
                disabledDate={(current) => { return current && current < moment().startOf('day');}}
                value={this.state.tabs[currentTab].service_start_date ? moment(this.state.tabs[currentTab].service_start_date) : null}
              />
              {(errors?.[`tabs[${currentTab}].service_start_date`] || mailErrors?.[`tabs[${currentTab}].service_start_date`]) ?
                <label className="new_err_msg"><i className="las la-info-circle"/>
                  {errors?.[`tabs[${currentTab}].service_start_date`] || mailErrors?.[`tabs[${currentTab}].service_start_date`]}</label> : ''}
            </div>

            <div className="half-fitem fitem" style={{ position: 'relative' }}>
              <label>Header Bag Pricing <sup>*</sup></label>
              <CurrencyFormat 
                value={this.state.tabs[currentTab].header_bag_price} 
                thousandSeparator={true} 
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                placeholder={"$ 0.00"}
                onValueChange={(values) => { 
                  const { formattedValue, value } = values;
                  this.onChangeHeaderBagPrice(value)
                }}/>
              {(errors?.[`tabs[${currentTab}].header_bag_price`] || mailErrors?.[`tabs[${currentTab}].header_bag_price`]) ?
                <label className="new_err_msg"><i className="las la-info-circle"/>
                  {errors?.[`tabs[${currentTab}].header_bag_price`] || mailErrors?.[`tabs[${currentTab}].header_bag_price`]}</label> : ''}
            </div>
            <div className="half-fitem fitem" style={{ position: 'relative' }}>
              <label>Roll Bag Pricing <sup>*</sup></label>
              <CurrencyFormat 
                value={this.state.tabs[currentTab].roll_bag_price} 
                thousandSeparator={true} 
                prefix={'$'}
                decimalSeparator={"."}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                placeholder={"$ 0.00"}
                onValueChange={(values) => { 
                  const { formattedValue, value } = values;
                  this.onChangeRollBagPrice(value)
                }}/>
              {(errors?.[`tabs[${currentTab}].roll_bag_price`] || mailErrors?.[`tabs[${currentTab}].roll_bag_price`]) ?
                <label className="new_err_msg"><i className="las la-info-circle"/>
                  {errors?.[`tabs[${currentTab}].roll_bag_price`] || mailErrors?.[`tabs[${currentTab}].roll_bag_price`]}</label> : ''}
            </div>
          </div>

        </div>
         
        <div className="pt-20 pb-10">
          <h3 className="px-30 font-weight-bold">Services</h3>
          {serviceItems?.length > 0 ?
            <div className="tbl-block propose-tbl-block">
              <div className={'tbl-head'}>
                {/* <span className="tbl-cell prs">Service</span> */}
                <span className="tbl-cell item">Service <sup>*</sup></span>
                {/* <span className="tbl-cell model">Model</span> */}
                <span className="tbl-cell reg">Frequency <sup>*</sup></span>

                <span className="tbl-cell desc">Description</span>
              
                <span className="tbl-cell qty">Quantity <sup>*</sup></span>

                <span className="tbl-cell cord">Coordinates <sup>*</sup></span>

                <span className="tbl-cell disc">Discount</span>

                <span className="tbl-cell ratee">Rate  <sup>*</sup></span>
                <span className="tbl-cell ttl">Total</span>
                {/* <span className="tbl-cell sh">S&H ($)</span> */}
                <div className="tbl-cell ant-ico-del">&nbsp;</div>
              </div>
              {map(serviceItems, this.renderItemRowService )}
            </div>
            : <div className="px-30 fs-14">
              <p className="font-weight-bold mb-10">No Service yet</p>
              <p className="mb-20 opacity-5">To add service to this proposal, click the add button below</p>
            </div>
          }

          {(errors?.[`tabs[${currentTab}].items`] || mailErrors?.[`tabs[${currentTab}].items`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].items`] || mailErrors?.[`tabs[${currentTab}].items`]}</label> : ''}
          <div className="btngrp py-0 px-30">
            <button 
              className={`btn ${tabs?.length === 0 ? 'disabled' : 'btn-warning px-15'}`}
              disabled={tabs?.length === 0}
              onClick={() => this.onAddItemService()}
            >
              <PlusCircleOutlined/>&nbsp;&nbsp;Add Item
            </button>
            
            {serviceItems?.length > 0 ?
              <button
                className={`btn ${tabs?.length === 0 ? 'disabled' : 'btn-txt'}`}
                disabled={tabs?.length === 0}
                onClick={() => this.onClearAllService()}
              >
                Clear All Item
              </button>: ""}
         
          </div>
        </div>

        <div className="pt-20 pb-10">
          <h3 className="px-30 font-weight-bold">Product</h3>
          {productItems?.length > 0 ?
            <div className="tbl-block propose-tbl-block">
              <div className={'tbl-head'}>
                {/* <span className="tbl-cell prs">Product</span> */}
                <span className="tbl-cell item">Product <sup>*</sup></span>
                <span className="tbl-cell model">Model <sup>*</sup></span>
                {/* <span className="tbl-cell reg">Regularity</span> */}
                <span className="tbl-cell desc">Description</span>
                <span className="tbl-cell qty">Quantity <sup>*</sup></span>
                <span className="tbl-cell disc">Discount</span>
              
                <span className="tbl-cell ratee">Rate <sup>*</sup></span>
            
                <span className="tbl-cell sh">S&H <sup>*</sup></span>
                <span className="tbl-cell ttl">Total</span>
                <div className="tbl-cell ant-ico-del">&nbsp;</div>
              </div>
              {map(productItems ,this.renderItemRowProduct)}
            </div>
            : <div className="px-30 fs-14">
              <p className="font-weight-bold mb-10">No product yet</p>
              <p className="mb-20 opacity-5">To add product to this proposal, click the add button below</p>
            </div>
          }
          {(errors?.[`tabs[${currentTab}].items`] || mailErrors?.[`tabs[${currentTab}].items`]) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>
              {errors?.[`tabs[${currentTab}].items`] || mailErrors?.[`tabs[${currentTab}].items`]}</label> : ''}
          <div className="btngrp py-0 px-30">
            <button className={`btn ${tabs?.length === 0 ? 'disabled' : 'btn-warning px-15'}`} disabled={tabs?.length === 0} onClick={() => this.onAddItemProduct()}><PlusCircleOutlined/>&nbsp;&nbsp;Add Item</button>
            {productItems?.length > 0 ?
              <button className={`btn ${tabs?.length === 0 ? 'disabled' : 'btn-txt'}`} disabled={tabs?.length === 0} onClick={() => this.onClearAllProduct()}>Clear All Item</button>:""}
          </div>
        </div>
      </React.Fragment>
    )
  }

  onChangeHeaderBagPrice(value ){
    const {tabs, currentTab} = this.state;
    const re = /^[0-9\b]+$/;
    // if (value === '' || re.test(value)) {
    tabs[currentTab].header_bag_price = value;
    this.setState({tabs});
    // }
  }

  onChangeStartDate(value){
    const {tabs, currentTab} = this.state;
    let date = moment(value).format('YYYY-MM-DD');
    tabs[currentTab].service_start_date  = date;
    this.setState({tabs});

  }

  onChangeRollBagPrice(value ){
    const {tabs, currentTab} = this.state;
    const re = /^[0-9\b]+$/;
    //  if (value === '' || re.test(value)) {
    tabs[currentTab].roll_bag_price = value;
    this.setState({tabs});
  //  }
  }

  // to render location modal
  renderLocations = () => {
    const {location, mapZoom, showLocation} = this.state;

    return (
      <div id={'org-map'} className="bdr-wrap mt-0" onClick={() => this.toggleLocation()} style={{'justifyContent': !isEmpty(location?.markers) ? 'flex-start' : 'center'}}>
        {
          (!isEmpty(location?.markers) && !showLocation) ?
            <div className='map' style={{'justifyContent': 'center', 'alignItems': 'center', 'height': '100%', 'display': 'flex', 'flexDirection': 'column'}}>
              <CustomMap zoom={mapZoom} markers={location?.markers} containerStyle={{width: '400px', height: '200px'}} />
            </div> : <div style={{'justifyContent': 'center', 'alignItems': 'center', 'display': 'flex', 'flexDirection': 'column'}}>
              <EnvironmentOutlined />
              <h3>Locations</h3>
              <p>Click  to add locations.</p>
            </div>
        }
      </div>
    )
  }

  // to render location modal
  // renderCoordinates = () => {
  //   const {location, mapZoom, showLocation} = this.state;
  
  //   return (
  //     <div id={'org-map'} className="bdr-wrap mt-0" onClick={() => this.toggleLocation()} style={{'justifyContent': !isEmpty(location?.markers) ? 'flex-start' : 'center'}}>
  //       {
  //         (!isEmpty(location?.markers) && !showLocation) ?
  //           <div className='map' style={{'justifyContent': 'center', 'alignItems': 'center', 'height': '100%', 'display': 'flex', 'flexDirection': 'column'}}>
  //             <CustomMap zoom={mapZoom} markers={location?.markers} containerStyle={{width: '400px', height: '200px'}} />
  //           </div> : <div style={{'justifyContent': 'center', 'alignItems': 'center', 'display': 'flex', 'flexDirection': 'column'}}>
  //             <EnvironmentOutlined />
  //             <h3>Locations</h3>
  //             <p>Click  to add locations.</p>
  //           </div>
  //       }
  //     </div>
  //   )
  // }

  renderMailBox = () => {
    const {email_body, to, subject, email_signature, mailErrors} = this.state;
    const {isEdit} = this.props;

    return (
      <div className="htmeditor">
        <div className="fgrp">
          <h6>To:</h6>
          <input
            type="text"
            value={to || ''}
            name="to"
            className="plain-control"
            onChange={(e) => this.onTextChange(e)}
          />
        </div>
        {mailErrors?.[`to`] ? <label className="new_err_msg" style={{marginLeft: "10px"}}><i className="las la-info-circle"/>{mailErrors?.[`to`]}</label> : ''}
        <div className="fgrp">
          <h6>Subject:</h6>
          <input
            type="text"
            value={subject || ''}
            name="subject"
            className="plain-control"
            onChange={(e) => this.onTextChange(e)}
          />
        </div>
        {mailErrors?.[`subject`] ? <label className="new_err_msg" style={{marginLeft: "10px"}}><i className="las la-info-circle"/>{mailErrors?.[`subject`]}</label> : ''}

        <ReactQuill value={email_body}
          onChange={(value) => this.onTextChange({target: {name: 'email_body', value}})} />
        {mailErrors?.[`email_body`] ? <label className="new_err_msg" style={{marginLeft: "10px"}}><i className="las la-info-circle"/>{mailErrors?.[`email_body`]}</label> : ''}
        <div className="sign">
          <b className="d-block">Signature:</b>
          <textarea
            type="text"
            placeholder={'Name, Position, Company Name, Phone, Email, Fax'}
            value={email_signature}
            name="email_signature"
            className="plain-control mt-10 mb-0 d-block"
            onChange={(e) => this.onTextChange(e)}
          />
          {mailErrors?.[`email_signature`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{mailErrors?.[`email_signature`]}</label> : ''}
          {/*<span className="mt-10 mb-0 d-block">Name, Position, Company Name, Phone, Email, Fax</span>*/}
        </div>
        <div className="btn-grp text-right">
          <button className="btn btn-bdr" onClick={() => this.onClearMailBox()}>Cancel</button>
          {isEdit ?
            <button
              className={`btn btn-bdr`}
              // disabled={!isValid}
              onClick={() => this.validate_mail('save_update')}>Save/Update</button> : ''}
          <button
            className={`btn btn-warning`}
            // disabled={!isValid}
            onClick={() => this.validate_mail('send')}>Send</button>
        </div>

      </div>
    )
  }

  render() {
    const {
      tabs,
      currentTab,
      siteSurvey,
      workScope,
      mapNotes,
      showPreview,
      coverLetter,
      showLocation,
      isCloseProposal,
      isActivateService,
      isDetails,
      loader,
      commercialProposalDetail,
      location,
      coordinate,
      getProposalPdf,
      currentPosition,
      quoteDetail,
      showConfirmation,
      mapZoom,
      errors,
      mailErrors,
      showCoordinates,
      fieldOffice
    } = this.state;
    const { patchCommercialProposal, isEdit } = this.props;
    return (
      <div className="block-row mb-100" id="container">
        <div className={'proposal-head flex'}>
          {loader && <Loader />}
          <div className={"flex-1 pleft"}>
            <div className="flex ai-center mb-30">
              <span>{quoteDetail?.proposal_number ? `#${quoteDetail?.proposal_number}` : ''}</span>
              {isEdit ? <div className="btngroup">
                <button type="button" className={`btn btn-brand btn-bdr`} onClick={() => this.validate('duplicate')}>Duplicate</button>
                <button type="button" className={`btn btn-brand btn-bdr`} onClick={() => this.validate('export')}>Export</button>
                <button type="button" className={`btn btn-brand btn-bdr`} onClick={() => this.validate('print')}>Print</button>
              </div> : ''}
              <a style={{"display": 'none'}} ref={e => this.link = e} download={getProposalPdf} href={getProposalPdf}><u>{'Download'}</u></a>
            </div>
            <div className="steps">
              {this.renderSteps()}
            </div>
          </div>
          <div className={'flex-auto pright'}>
            {this.renderBasicDetails()}
          </div>
        </div>

        <div className="card">
          <div className="card-title pb-0">
            <ul className="tabs dark">
              {
                map(tabs, (item, index) => {
                  const error_tab = !isEmpty(errors) ? Object.keys(errors)?.find(x => x.includes(`tabs[${index}]`)) : Object.keys(mailErrors)?.find(x => x.includes(`tabs[${index}]`))
                  return (<li key={`tab${index}`} className={currentTab === index ? 'active' : ''}
                    style={{border: error_tab ? '1px solid red' : ''}} >
                    <div className={"flex"}>
                      <div className="flex-1" onClick={(e) => {
                        e.preventDefault();
                        this.tabChange(index)
                      }}>
                        {item.title}
                      </div>
                      
                    </div>
                  </li>)
                })
              }
              <li style={{'fontSize': '18px'}} onClick={(e) => {
                e.preventDefault();
                this.onAddTab()
              }}>
                <span className="flex ai-center">
                  <PlusCircleOutlined/>
                </span>
              </li>
            </ul>
          </div>
          <div className="card-body px-0">
            {this.renderItemTable()}
          </div>
        </div>

        <div className={'card mt-10 survey'}>
          <div className="form-group">
            <div className="fitem">
              <label>Result of Site Survey</label>
              <textarea
                rows="4"
                name="siteSurvey"
                type="text"
                className="bdr-control"
                placeholder={"Results of site survey"}
                value={siteSurvey || ''}
                onChange={(e) => this.onTextChange(e)}/>
            </div>
            <div className="fitem">
              <label>High Level Overview - Scope of Work</label>
              <textarea
                rows="4"
                name="workScope"
                type="text"
                className="bdr-control"
                placeholder={"High level overview - scope of work"}
                value={workScope || ''}
                onChange={(e) => this.onTextChange(e)}/>
            </div>
            <div className="fitem">
              <label>Map Notes</label>
              <textarea
                rows="4"
                name="mapNotes"
                type="text"
                className="bdr-control"
                placeholder={"Map notes"}
                value={mapNotes || ''}
                onChange={(e) => this.onTextChange(e)}/>
            </div>
            {this.renderLocations()}
          </div>
          <div className="flex-1">
            {this.renderUpload()}
            {this.renderMailBox()}
          </div>

        </div>
        <div className="fix-btn-grp">
          <button className="btn btn-white" onClick={() => this.onCancel()}>Cancel</button>
          {isEdit ?
            <button className="btn btn-white" onClick={() => this.toggleCloseProposal()}>Close Proposal</button> : ''}
          <button className={`btn btn-warning`} onClick={() => this.validate('active')}>
            Activate Service
          </button>
          {
            isEdit ? <button className={`btn btn-warning`} onClick={() => this.validate('edit')}>Save Proposal</button>
              : <button className={`btn btn-warning`} onClick={() => this.validate('save')}>Save Proposal</button>
          }
        </div>
        {showPreview && <PreviewLetter
          file={coverLetter?.imageUrl}
          visible={showPreview}
          handleCancel={() => this.togglePreview(false)}/>}
        {showLocation && <DefineLocation
          zoom={mapZoom}
          visible={showLocation}
          quoteDetail={quoteDetail}
          onCancel={() => this.toggleLocation()}
          onSave={(markers, mapZoom) => {
            this.onSaveMarkers(markers);
            this.setState({mapZoom})
          }}
          markerList={!isEmpty(location.markers) ? location.markers : !isEmpty(currentPosition) ? [currentPosition] : []}/>}
          
        {showCoordinates && <DefineCoordinates
          zoom={mapZoom}
          visible={showCoordinates}
          quoteDetail={quoteDetail}
          onCancel={() => this.toggleCoordinates(0)}
          onSave={(markers, mapZoom) => {
            this.onSaveMarkersCoordinates(markers);
            this.setState({mapZoom})
          }}
          markerList={!isEmpty(coordinate.markers) ? coordinate.markers : !isEmpty(currentPosition) ? [] : []}
          currentPosition = {!isEmpty(currentPosition) ? [currentPosition] : [] }
          address ={!isEmpty(quoteDetail?.address?.formatted_address) ? quoteDetail?.address?.formatted_address : fieldOffice?.data?.address}
        />
          
        }
        
        {isCloseProposal && <ProposalClose
          visible={isCloseProposal}
          onCancel={() => this.toggleCloseProposal()}
          onChangeView={this.props.onChangeView}
          patchCommercialProposal={patchCommercialProposal}
          commercialProposalDetail={commercialProposalDetail}
          getProposalList={this.props.getProposalList}
        />}
        {isActivateService && <ActivateService
          visible={isActivateService}
          onCancel={() => this.toggleActivateProposal()}
          onActiveService={(service_contract) => {
            const {quoteDetail, check_email} = this.state;
            if (check_email) {
              Modal.error({
                title: 'Error',
                content: `Customer is already exist with this email (${quoteDetail?.email_address})`,
              });
              this.toggleActivateProposal()
            } else if (isEmpty(quoteDetail?.address?.address)) {
              Modal.error({
                title: 'Error',
                content: 'Please update your address',
                okText: 'Update address',
                onOk: () => {
                  this.props.history.push('/commercial/new-proposal', { query: { 'quoteDetail': quoteDetail } })
                }
              });
              this.toggleActivateProposal()
            } else {
              if (isEdit) {
                this.onUpdateProposal(service_contract)
              } else {
                this.onSaveProposal(service_contract)
              }
            }
          }}/>}
        {isDetails && <Details
          visible={isDetails}
          handleCancel={this.onExportClick}
          generatePDF={this.generatePDF}
          commercialProposalDetail={commercialProposalDetail}
        />}
        <Modal
          title="Send Mail"
          visible={showConfirmation}
          okText={'Yes'}
          cancelText={'No'}
          onOk={() => this.onSaveMail()}
          onCancel={() => this.setState({showConfirmation: false})}
          className="delete_user_modal"
          width={400}
        >
          <h2> Are You Sure ?</h2>
        </Modal>
      </div>
    );
  }
}

export default AddProposal;
